(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.topHeader = document.querySelector('top-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.topHeaderBounds = {};

      this.setHeaderHeight();

      this._mql = window.matchMedia('(max-width: 1299px)');
      this._onBreakpointChange = this.onBreakpointChange.bind(this);
      this._mql.addEventListener('change', this._onBreakpointChange);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.scrollTicking = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);
      this.onResizeHandler = this.onResize.bind(this);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });
      window.addEventListener('resize', this.onResizeHandler);

      this.createObserver();
      this.onScroll();
    }

    setHeaderHeight() {
      // Reading offsetHeight outside a frame callback forces a synchronous reflow.
      requestAnimationFrame(() => {
        document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
      });
    }

    onBreakpointChange() {
      this.setHeaderHeight();
      this.createObserver();
    }

    onResize() {
      window.clearTimeout(this.resizeTimeout);
      this.resizeTimeout = setTimeout(() => this.setHeaderHeight(), 150);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      window.removeEventListener('resize', this.onResizeHandler);
      window.clearTimeout(this.resizeTimeout);
      if (this._mql) {
        this._mql.removeEventListener('change', this._onBreakpointChange);
      }
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);

      if (this.topHeader) {
        requestAnimationFrame(() => {
          const rect = this.topHeader.getBoundingClientRect();
          this.topHeaderBounds = { bottom: rect.bottom + window.scrollY };
        });
      }
    }

    onScroll() {
      // Coalesce bursts of scroll events into one read/write pass per frame.
      if (this.scrollTicking) return;
      this.scrollTicking = true;

      requestAnimationFrame(() => {
        this.scrollTicking = false;
        this.handleScroll();
      });
    }

    handleScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      // Control top-header visibility with hysteresis to prevent scroll oscillation
      if (this.topHeader && this.topHeaderBounds.bottom) {
        const isHidden = this.topHeader.classList.contains('scrolled-past-header');
        if (!isHidden && scrollTop > this.topHeaderBounds.bottom) {
          this.topHeader.classList.add('scrolled-past-header');
          this.topHeader.setAttribute('inert', '');
          this.topHeader.setAttribute('aria-hidden', 'true');
        } else if (isHidden && scrollTop <= this.topHeaderBounds.bottom * 0.3) {
          this.topHeader.classList.remove('scrolled-past-header');
          this.topHeader.removeAttribute('inert');
          this.topHeader.removeAttribute('aria-hidden');
        }
      }

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        this.hide();
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          this.reveal();
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          this.hide();
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.reset();
      }

      this.currentScrollTop = scrollTop;
    }

    stickyTargets() {
      if (this._stickyTargets) return this._stickyTargets;

      const targets = [
        this.topHeader,
        document.querySelector('.facets-sidebar-sticky'),
        document.querySelector('.sticky-toolbar-mobile'),
      ].filter(Boolean);

      // The header upgrades before the rest of the page is parsed, so only keep the
      // lookup once the document is done and the targets are guaranteed to exist.
      if (document.readyState !== 'loading') this._stickyTargets = targets;

      return targets;
    }

    toggleStickyTargets(isHidden) {
      this.stickyTargets().forEach((target) => target.classList.toggle('hidden-header', isHidden));
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.toggleStickyTargets(true);
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      this.toggleStickyTargets(false);
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      this.toggleStickyTargets(false);
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
